import { requestHeaders } from '../helpers/csrf';
import { readResponsePayload, resolveErrorMessage } from '../helpers/error-handler';

class DeleteConfirmationService {
    static async execute(options = {}) {
        const {
            notification,
            url,
            title = 'Confirmar exclusão',
            message = 'Tem certeza que deseja excluir este registro?',
            loadingMessage = 'Excluindo...',
            errorTitle = 'Erro',
            defaultErrorMessage = 'Não foi possível excluir o registro.',
            successMessage = null,
        } = options;

        if (!notification || !url) return false;

        const confirmed = await notification.confirm(
            title,
            message,
            null,
            'Sim, quero continuar',
            'Não, Cancelar',
            'warning'
        );

        if (!confirmed) return false;

        try {
            notification.showLoading(loadingMessage);

            const response = await fetch(url, {
                method: 'DELETE',
                headers: requestHeaders({ Accept: 'application/json' }),
            });

            notification.hideLoading();

            if (!response.ok) {
                const payload = await readResponsePayload(response);
                const errorMessage = resolveErrorMessage(payload, defaultErrorMessage);
                notification.showError(errorTitle, errorMessage);
                return false;
            }

            if (successMessage) {
                notification.showSuccess(successMessage);
            }

            return true;
        } catch (error) {
            notification.hideLoading();
            notification.showError(errorTitle, resolveErrorMessage(error, defaultErrorMessage));
            return false;
        }
    }
}

export default DeleteConfirmationService;
